import axios from "axios";
import { message } from "antd";

const BackendHost = ''

export const VcApiPath = '/vc/api/v1'
export const TtsApiPath = '/tts/api/v1'
export const TtsApiPathv2 = '/api/v2/tts'
export const GeneratePath = '/mtaudiolab/api/v1'
export const VcBackendUri = BackendHost + VcApiPath
export const TtsBackendUri = BackendHost + TtsApiPath
export const UploadPath = 'https://api.mthreads.com/asr-dev-apis/api/v1/asr'
const VoiceService = axios.create({
    timeout: 100000,
    headers: {
        'content-type': "application/json",
        'Authorization': 'vWlQd2UD1qhR9VgEm13WAoVtm6fZavfoch7x56ardGzGkDR0bx5TuCcHJhetBUSQ'
    }
});

VoiceService.interceptors.request.use(
    (config: any) =>
        // Do something before request is sent
        config,
    (error: any) =>
        // Do something with request error
        Promise.reject(error)
);

VoiceService.interceptors.response.use(
    (response: any) =>
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        response,
    (error: any) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        const errMsg =
            error?.response?.data?.message ||
            error?.response?.message ||
            error?.message;
        message.error(errMsg);
        return Promise.reject(error);
    }
);

export default VoiceService;
